import { HttpTypes } from "@medusajs/types"

type CartShippingState =
  | {
      shipping_methods?: HttpTypes.StoreCartShippingMethod[] | null
      shipping_total?: number | null
    }
  | null
  | undefined

/**
 * A shipping method is only attached to the cart once the customer reaches
 * checkout. Before that, estimate using the cheapest available shipping
 * option — matching the reference site, which always shows a shipping
 * charge in cart totals rather than hiding it until checkout.
 */
export function getShippingEstimate(
  cart: CartShippingState,
  shippingOptions: HttpTypes.StoreCartShippingOption[]
) {
  const shippingMethod = cart?.shipping_methods?.[0]
  const cheapestOption = [...shippingOptions]
    .filter((option) => typeof option.calculated_price?.calculated_amount === "number")
    .sort(
      (a, b) =>
        (a.calculated_price!.calculated_amount as number) -
        (b.calculated_price!.calculated_amount as number)
    )[0]

  const label = shippingMethod?.name ?? cheapestOption?.name
  const amount = shippingMethod
    ? cart?.shipping_total ?? 0
    : cheapestOption?.calculated_price?.calculated_amount ?? 0

  return { label, amount, isAttached: !!shippingMethod }
}
